import React, { useMemo } from 'react';
import StepProgressBar from './StepProgressBar';
import { useSelector } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import {MainContainer} from './ProgressBar.styled';
import { isTransferSurgery } from 'src/utils/util';

function ProgressBar({
    steps,
    currentActivity,
    stepValidation = () => true,
    category,
    sameBatchAllocationError = false,
    background,
    boxShadow,
    margin,
    padding,
    marginMb,
    progressColor,
    stepperBackgroundColor,
    progressBarIconClickHandler,
    procedurePageVisibility,
    countryCode,
    procedureDataPhysician,
    replenishmentPageVisibilityUsage,
    isFromReportUsage = false,
}) {
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const parentSurgeryMyCaseRef = useSelector(
        (state) => state.surgeryDetailsReducer?.surgeryData?.myCaseRef
    );

    const displayHeight = useMemo(() => {
    if ((isCondensedView && window.innerWidth > sizes.mobileDevice) || (isCondensedView && window.innerWidth <= sizes.mobileDevice)) {
            return '72px';
        }
        return '72px';
    }, [isCondensedView]);

    const containerProps = useMemo(() => {
        const isTransferWithReference =
            isTransferSurgery() && !!parentSurgeryMyCaseRef;

        if (isCondensedView) {
            return {
                boxShadow: boxShadow || 'none',
                background: background || 'none',
                margin: margin || '0px 0px 24px 0px',
                padding: padding || '0px 0px 24px 0px',
                marginMb: marginMb || '15px -15px 2px -15px',
                paddingMb: isTransferWithReference
                    ? '30px 0px 0px 0px'
                    : isFromReportUsage ? '0px 0px 5px 0px' : '0px 0px 8px 0px',
            };
        }
        return {
            boxShadow: boxShadow || '0px 0px 6px #00000029',
            background: background || '#ffffff 0% 0% no-repeat padding-box',
            margin: margin || '10px 0px 2px 0px',
            padding: '0px',
            marginMb: marginMb || '0px',
            paddingMb: '0px 0px 8px 0px',
        };
    }, [
        isCondensedView,
        background,
        boxShadow,
        margin,
        padding,
        marginMb,
        parentSurgeryMyCaseRef,
    ]);    // Convert props to use $ prefix for styled-components

    const styledContainerProps = {};
    Object.keys(containerProps).forEach(key => {
        styledContainerProps[`$${key}`] = containerProps[key];
    });

    return (
        <MainContainer
            {...styledContainerProps}
        >            
            <StepProgressBar
                steps={steps}
                currentActivity={currentActivity}
                stepValidation={stepValidation}
                category={category}
                sameBatchAllocationError={sameBatchAllocationError}
                height={displayHeight}
                progressColor={progressColor}
                stepperBackgroundColor={stepperBackgroundColor}
                progressBarIconClickHandler={progressBarIconClickHandler}
                procedurePageVisibility={procedurePageVisibility}
                countryCode={countryCode}
                procedureDataPhysician={procedureDataPhysician}
                replenishmentPageVisibilityUsage={
                    replenishmentPageVisibilityUsage
                }
                isFromReportUsage={isFromReportUsage}
            />
        </MainContainer>
    );
}

export default ProgressBar;
